var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Index "),_c('button',{on:{"click":function($event){return _vm.$router.push('/user/about')}}},[_vm._v("Click to Navigate")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }